import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { getDisplayName } from '../../utils/hocHelpers';

export default function withCharCounter(Input) {
  const Component = (props) => {
    const [internalValue, setInternalValue] = useState(props.value || '');

    const realTimeData = props.realTimeData;

    const handleChange = useCallback(
      ({ target }) => {
        setInternalValue(target.value);
        if (realTimeData) {
          realTimeData({ target });
        }
      },
      [realTimeData]
    );

    return (
      <Input
        {...props}
        {...(props.maxLengthIndicatorLimit && {
          charCount: `${internalValue.length}/${props.maxLengthIndicatorLimit}`,
          realTimeData: handleChange
        })}
      />
    );
  };

  Component.displayName = `withCharCounter(${getDisplayName(Input)})`;

  Component.propTypes = {
    maxLengthIndicatorLimit: PropTypes.string,
    realTimeData: PropTypes.func
  };

  Component.defaultProps = {
    maxLengthIndicatorLimit: undefined,
    realTimeData: undefined
  };

  return Component;
}
